<app-fn-ui-select name="condition-operator"
                  class="selectpicker dh-select"
                  [(ngModel)]="operator"
                  [options]="operatorList"
                  [displayProperty]="'alias'"
                  [valueProperty]="'value'"
                  [required]="true"
                  (selectionChanged)="onOperatorChange($event)">
</app-fn-ui-select>
